import { Box, Flex, Text, VStack } from '@minetrace/ui'
import { useFormColors, FormSection } from '@minetrace/ui/forms'
import { LuDatabase as Database } from 'react-icons/lu'
import type { RecpoRecordResponse } from '../../../api/models/response/consultarRuc'
import { etiquetaSituacionRecpo } from '../../../lib/recpo'

interface Step6RecpoProps {
  mode: 'edit' | 'readonly'
  recpoRecords: RecpoRecordResponse[]
}

export default function Step6Recpo({ recpoRecords }: Step6RecpoProps) {
  const c = useFormColors()

  return (
    <FormSection icon={Database} titleTid="proveedores.wizard.step6.title" descriptionTid="proveedores.wizard.step6.description">
      {recpoRecords.length > 0 ? (
        <VStack gap={3} alignItems="stretch">
          {recpoRecords.map((rec, idx) => (
            <Flex key={idx} p={4} bg={c.bgHover} borderRadius="xl" gap={4} alignItems="center">
              <Box flex={1}>
                <Text fontSize="sm" fontWeight="600" color={c.text} fontFamily="monospace">{rec.recpoCode}</Text>
                <Flex gap={3} mt={1} flexWrap="wrap">
                  {rec.resourceDate && (
                    <Text tid="proveedores.wizard.step6.dateLabel" values={{ date: rec.resourceDate }} fontSize="xs" color={c.textMuted} />
                  )}
                  {rec.condition && (
                    <Text fontSize="xs" color={c.textMuted}>{rec.condition}</Text>
                  )}
                </Flex>
              </Box>
              {rec.situation && (
                <Box
                  px={2}
                  py={0.5}
                  borderRadius="md"
                  fontSize="10px"
                  fontWeight="bold"
                  textTransform="uppercase"
                  bg={`${c.accent}20`}
                  color={c.accent}
                >
                  {etiquetaSituacionRecpo(rec.situation)}
                </Box>
              )}
            </Flex>
          ))}
        </VStack>
      ) : (
        <Box
          p={4}
          textAlign="center"
          border="1px dashed"
          borderColor="gray.200"
          borderRadius="xl"
        >
          <Text tid="proveedores.wizard.step6.emptyMessage" fontSize="sm" color={c.textMuted} />
        </Box>
      )}
    </FormSection>
  )
}
